import React, { useEffect, useRef } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from "../pages/Home";
import SignUp from "../pages/SignUp";
import VerifyEmail from "../pages/VerifyEmail";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import InvitationAccept from "../pages/InvitationAccept";
import NotFound from "../pages/NotFound";
import { AuthProvider } from "../auth/Auth";
import { RequireAuth } from "../auth/RequireAuth";
import Settings from "../pages/Settings";
import SocialAuth from "../pages/SocialAuth";




const AppRoutes = () => {

  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<RequireAuth><Home /></RequireAuth>} />
        <Route path="/chat/:uuid" element={<RequireAuth><Home /></RequireAuth>} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/invitation/:token" element={<InvitationAccept />} />
        <Route path="/settings" element={<RequireAuth><Settings /></RequireAuth>} />
        <Route path="/azuread" element={<SocialAuth />} />
        <Route path="/slack" element={<SocialAuth />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
};
export default AppRoutes;
